import Svg from '../common/Svg';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ReactEcharts from "echarts-for-react";
import { useDispatch, useSelector } from 'react-redux';
import { Link, Route, useNavigate, useParams } from 'react-router-dom';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { getSurveyResult, getSurveySectionData } from '../store/actions/surveyFormAction';
import Report from './report/Report';


export default function ThankyouBackup() {

    return (
        <>
            <div className='thank-you-page'>
                <div className="container" id='container1234'>
                    <div className="row">
                        <div className="col-lg-6 mb-3 mb-lg-0">
                            <div className="text-wrap">
                                <div className="logo-wrap">
                                    <Svg name="vodafone-logo-colored" />
                                </div>
                                <h1><span className='text-primary'>John Doe,</span> TCX Tech is at the <span className='text-primary'>‘Cloud Novice’</span> stage</h1>
                                {/* This can be used for Progress */}
                                <div className="progress-wrapper">
                                    <div className="progress-output">
                                        <ul progress-width="50">
                                            <li className={'icon-text-wrap active'}>
                                                <div className="icon-wrap">
                                                    <Svg name="beginner-icon" />
                                                </div>
                                                <div className="text">Cloud Novice</div>
                                            </li>
                                            <li className={'icon-text-wrap'}>
                                                <div className="icon-wrap">
                                                    <Svg name="intermediate-icon" />
                                                </div>
                                                <div className="text">Cloud Explorer</div>
                                            </li>
                                            <li className={'icon-text-wrap'}>
                                                <div className="icon-wrap">
                                                    <Svg name="advanced-icon" />
                                                </div>
                                                <div className="text">Cloud Innovator</div>
                                            </li>
                                            {/* Change progress width, if stage is beginner, width is 0 and if advanced width is 100 */}

                                            <div className="result-bar" style={{ width: '50%' }}> </div>


                                        </ul>
                                    </div>
                                </div>
                                {/* This can be used for Progress */}
                                <p>Your personalised report is now available! Explore your insights and recommendations today.</p>
                                <div className="button-wrap d-flex flex-wrap">
                                    <Link to='' className='btn btn-primary me-0 me-md-3 mb-3'> View report </Link>
                                    <button className='btn btn-transparent btn-icon mb-3'>
                                        Download report
                                        <Svg name="button-icon" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            
                            <div className="graph-box">
                                <div className="chart-wrapper">
                                    {/* <ReactEcharts style={style} option={option} /> */}
                                </div>
                                <div className="value-wrapper">
                                    {/* {
                                        Object.keys(result?.section_maturity_score ?? {})?.map((key, index) => {
                                            return (
                                                <div className={`value-box value-${(index % 6) + 1}`} key={index}>
                                                    <div className="number">{(result?.section_maturity_score[key])}</div>
                                                    <div className="text">{surveySections[key]?.name}</div>
                                                </div>
                                            )
                                        })
                                    } */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}
